import { render, staticRenderFns } from "./add-role.vue?vue&type=template&id=31a736b0&scoped=true&"
import script from "./add-role.vue?vue&type=script&lang=js&"
export * from "./add-role.vue?vue&type=script&lang=js&"
import style0 from "./add-role.vue?vue&type=style&index=0&id=31a736b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a736b0",
  null
  
)

export default component.exports